// extracted by mini-css-extract-plugin
export default {"link":"_T9houDrpAr8bZWZEBOA"};